import { MS_THREADS } from './mockData';
import type { MessagesHeaderStats, MsToneKey } from './types';
import { MS_TONE } from './mockData';

export { MS_TONE };

export function msInitials(name: string): string {
  return name
    .split(' ')
    .filter((w) => w.length > 1)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

export function messagesHeaderStats(): MessagesHeaderStats {
  return {
    total: MS_THREADS.length,
    unread: MS_THREADS.reduce((sum, t) => sum + t.unread, 0),
    emergency: MS_THREADS.filter((t) => t.currentTopic === 'emergency').length,
  };
}

export function toneStyle(tone: MsToneKey) {
  return MS_TONE[tone] ?? MS_TONE.neutral;
}

export function splitPatientName(name: string): { firstName: string; lastName: string } {
  const parts = name.split(' ');
  if (parts.length <= 1) return { firstName: name, lastName: '' };
  return { firstName: parts.slice(0, -1).join(' '), lastName: parts[parts.length - 1] ?? '' };
}
